var __read = (this && this.__read) || function (o, n) {
    var m = typeof Symbol === "function" && o[Symbol.iterator];
    if (!m) return o;
    var i = m.call(o), r, ar = [], e;
    try {
        while ((n === void 0 || n-- > 0) && !(r = i.next()).done) ar.push(r.value);
    }
    catch (error) { e = { error: error }; }
    finally {
        try {
            if (r && !r.done && (m = i["return"])) m.call(i);
        }
        finally { if (e) throw e.error; }
    }
    return ar;
};
var __spread = (this && this.__spread) || function () {
    for (var ar = [], i = 0; i < arguments.length; i++) ar = ar.concat(__read(arguments[i]));
    return ar;
};
export var ColorUtils;
(function (ColorUtils) {
    var HEX_EXP = /^#[0-9a-f]{3,6}$/i;
    // 3 - 16 comma separated numbers
    var CSV_EXP = /(\s*[\d\.]+\s*,){2,15}\s*[\d\.]+\s*/g;
    var ColorModel = /** @class */ (function () {
        function ColorModel() {
        }
        return ColorModel;
    }());
    function is255(channels) {
        for (var i = 0; i < 3; i++) {
            var channelValue = "" + channels[i];
            if (parseFloat(channelValue) > 1) {
                return true;
            }
        }
        return false;
    }
    ColorUtils.is255 = is255;
    function isLight(outerRGB, innerRGB) {
        if (!innerRGB) {
            innerRGB = __spread(outerRGB);
        }
        // Convert RGB to HSP (Hue, Saturation, "Perceived Lightness"), a reliable metric for 'lightness'
        // Support outer and inner to account for gradients
        var outerHSP = rgbToHSP(outerRGB);
        var innerHSP = rgbToHSP(innerRGB);
        var hsp = (outerHSP + innerHSP) / 2;
        // 60% or below is considered 'dark'
        // 255 * 0.55 = 140.25
        return (hsp > 140.25);
    }
    ColorUtils.isLight = isLight;
    function getComputedColor(input) {
        var el = document.createElement('div');
        el.style.backgroundColor = input;
        document.documentElement.appendChild(el);
        var computedColor = window.getComputedStyle(el).backgroundColor.replace(/\s/g, '');
        window.document.documentElement.removeChild(el);
        return computedColor;
    }
    ColorUtils.getComputedColor = getComputedColor;
    function convertChannels(input) {
        var channels = input.slice(0, 4);
        if (channels.length === 3) {
            channels.push(1);
        }
        for (var i = 0; i < 4; i++) {
            var channelValue = "" + channels[i];
            channels[i] = parseFloat(channelValue);
            if (channels[i] < 0) {
                channels[i] = 0;
            }
            if (channels[i] > 255) {
                channels[i] = 255;
            }
        }
        if (channels[3] > 1) {
            channels[3] = 1;
        }
        return channels;
    }
    ColorUtils.convertChannels = convertChannels;
    // Convert a single color
    function convert(input) {
        var color;
        if (Array.isArray(input)) {
            color = convertChannels(input);
        }
        else if (typeof input === 'string') {
            var csvMatch = input.match(CSV_EXP);
            if (csvMatch) {
                color = convertChannels(csvMatch[0].split(','));
            }
            else {
                // See if the browser can compute the color
                var computedColor = getComputedColor(input);
                csvMatch = computedColor.match(CSV_EXP);
                if (csvMatch) {
                    color = convertChannels(csvMatch[0].split(','));
                }
            }
        }
        return color;
    }
    ColorUtils.convert = convert;
    function getColor(input) {
        // Convert input to 4 length array
        var color = convert(input);
        if (!color) {
            throw new TypeError('Invalid color input.');
        }
        // Scale color
        var scaledColor = scaleColor(color);
        var color1 = is255(color) ? scaledColor : color;
        var color255 = is255(color) ? color : scaledColor;
        return {
            '1': color1,
            '255': color255
        };
    }
    ColorUtils.getColor = getColor;
    function getColors(input) {
        var colors = [];
        if (typeof input === 'string') {
            var csvMatch = input.match(CSV_EXP);
            // Try to extract numbers from the string
            if (csvMatch) {
                input = csvMatch.join(',');
            }
            // Split it on commas
            input = input.split(',');
        }
        if (Array.isArray(input)) {
            var nestedArrays = Array.isArray(input[0]) && Array.isArray(input[1]);
            if (nestedArrays) {
                // Format is good as is
                colors = input;
            }
            else if (input.length <= 2) {
                // Arrays of 2 items or less can be CSS color name(s)
                colors = input.length === 1 ? input.concat(input) : input;
            }
            else {
                // Should be a set of numbers between 3 - 16
                var half = Math.floor(input.length / 2);
                // Greater than 4 is assumed to be two color values
                if (input.length > 4) {
                    colors = [input.slice(0, half), input.slice(half)];
                }
                else {
                    // Single color input, apply to both colors
                    colors = [input, input];
                }
            }
        }
        return colors.map(function (color) { return getColor(color); });
    }
    ColorUtils.getColors = getColors;
    function scaleColor(channels) {
        var _is255 = is255(channels);
        var scaledChannels = [];
        // Don't scale alpha channel
        for (var i = 0; i < 3; i++) {
            var scaledChannel = _is255 ? channels[i] / 255 : channels[i] * 255;
            if (_is255) {
                scaledChannel = Math.round(scaledChannel * 100) / 100;
            }
            else {
                scaledChannel = Math.round(scaledChannel);
            }
            scaledChannels.push(scaledChannel);
        }
        if (channels.length === 4) {
            scaledChannels.push(channels[3]);
        }
        return scaledChannels;
    }
    ColorUtils.scaleColor = scaleColor;
    function hexToRgba(hex, asDecimal) {
        if (asDecimal === void 0) { asDecimal = false; }
        // normalize hex
        hex = hex
            .replace(/^#?([a-f\d])([a-f\d])([a-f\d])$/i, function (m, r, g, b) {
            return [r, r, g, g, b, b].join('');
        }) // #fff -> #ffffff
            .replace(/^#?([a-f\d]{2})([a-f\d]{2})([a-f\d]{2})$/i, function (m, r, g, b) {
            return [r, g, b, 'ff'].join('');
        }); // #ffffff -> #ffffffff
        var regex = /^#?([a-f\d]{2})([a-f\d]{2})([a-f\d]{2})([a-f\d]{2})$/i.exec(hex); // #ffffffff
        var red = parseInt(regex[1], 16);
        var green = parseInt(regex[2], 16);
        var blue = parseInt(regex[3], 16);
        var alpha = parseInt(regex[4], 16) / 255; // important: 0...1
        if (asDecimal) {
            var rgb = _rgbToDecimal([red, green, blue]);
            return [rgb[0], rgb[1], rgb[2], alpha];
        }
        else {
            return [red, green, blue, alpha];
        }
    }
    ColorUtils.hexToRgba = hexToRgba;
    function hexToRgb(hex, asDecimal) {
        if (asDecimal === void 0) { asDecimal = false; }
        var rgba = hexToRgba(hex, asDecimal);
        return [rgba[0], rgba[1], rgba[2]];
    }
    ColorUtils.hexToRgb = hexToRgb;
    function rgbToHex(rgb, isDecimal) {
        if (isDecimal === void 0) { isDecimal = false; }
        if (isDecimal) {
            return toHex(_rgbFromDecimal(rgb));
        }
        else {
            return toHex(rgb);
        }
    }
    ColorUtils.rgbToHex = rgbToHex;
    function rgbToHSP(rgb) {
        var _a = __read(rgb, 3), r = _a[0], g = _a[1], b = _a[2];
        // HSP equation
        // http://alienryderflex.com/hsp.html
        var hsp = Math.sqrt(0.299 * (r * r) +
            0.587 * (g * g) +
            0.114 * (b * b));
        return hsp;
    }
    ColorUtils.rgbToHSP = rgbToHSP;
    function rgbaToHex(rgba, isDecimal) {
        if (isDecimal === void 0) { isDecimal = false; }
        var red = rgba[0];
        var green = rgba[1];
        var blue = rgba[2];
        var alpha = rgba[3] * 255; // important: 0...1 -> 0...255
        if (isDecimal) {
            return toHex(__spread(_rgbFromDecimal([red, green, blue]), [alpha]));
        }
        else {
            return toHex([red, green, blue, alpha]);
        }
    }
    ColorUtils.rgbaToHex = rgbaToHex;
    function _rgbToDecimal(rgb) {
        var result = rgb.map(function (value) {
            return value / 255;
        });
        return result;
    }
    function _rgbFromDecimal(rgb) {
        var result = rgb.map(function (value) {
            return Math.round(value * 255);
        });
        return result;
    }
    function toHex(values) {
        var hex = values
            .map(function (value) {
            var hexString = value.toString(16);
            return hexString.length % 2 ? "0" + hexString : hexString;
        })
            .join('');
        return "#" + hex;
    }
})(ColorUtils || (ColorUtils = {}));
